import React from 'react';
import Button from '../Button';
import Text from '../Text';
import BackupFooter from './BackupFooter';
import StateHeading from './StateHeading';
import UpgradeIcon from './icons/UpgradeIcon';
import { ConfirmationData, DataModelV2UpgradeModalProps } from './types';

type Props = ConfirmationData & { title: string } & Pick<
    DataModelV2UpgradeModalProps,
    'faqUrl' | 'actionPending' | 'onStartUpgrade' | 'onNotNow'
  >;

export default function Confirmation({
  title,
  transactionCount,
  lockedThroughYear,
  faqUrl,
  actionPending,
  onStartUpgrade,
  onNotNow,
}: Props) {
  return (
    <>
      <StateHeading title={title}>
        Your transactions will migrate, cost basis will be recalculated, and your original account stays
        protected.
      </StateHeading>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div className="grid items-start justify-items-center gap-6 rounded-lg bg-sub px-6 py-10 text-center sm:row-span-3 sm:grid-rows-subgrid">
          <UpgradeIcon name="check" boxed />
          <Text as="p" variant="base" className="text-lg font-medium">
            {transactionCount.toLocaleString('en-US')}{' '}
            {transactionCount === 1 ? 'transaction' : 'transactions'} will migrate
          </Text>
          <Text as="p" variant="muted" className="leading-6">
            This takes a few minutes
          </Text>
        </div>
        <div className="grid items-start justify-items-center gap-6 rounded-lg bg-sub px-6 py-10 text-center sm:row-span-3 sm:grid-rows-subgrid">
          <UpgradeIcon
            name={lockedThroughYear === undefined ? 'calculator' : 'lock'}
            boxed
            tone={lockedThroughYear === undefined ? 'primary' : 'success'}
          />
          <Text as="p" variant="base" className="text-lg font-medium">
            {lockedThroughYear === undefined
              ? 'Cost basis will be recalculated'
              : 'Locked years stay unchanged'}
          </Text>
          <div className="flex items-center gap-1 text-muted">
            {lockedThroughYear !== undefined && <UpgradeIcon name="lock" />}
            <Text variant="muted" className="leading-6">
              {lockedThroughYear === undefined
                ? 'No locked years on your account'
                : `${lockedThroughYear} and below`}
            </Text>
          </div>
        </div>
      </div>
      <div className="space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <Button type="button" variant="secondary" fullWidth onClick={onNotNow} disabled={actionPending}>
            Not now
          </Button>
          <Button
            type="button"
            variant="primary"
            fullWidth
            loading={actionPending}
            disabled={actionPending}
            onClick={onStartUpgrade}
          >
            Start upgrade
          </Button>
        </div>
        <BackupFooter faqUrl={faqUrl} />
      </div>
    </>
  );
}
